import { useTranslation } from "react-i18next";
import BreadCrump from "../tools/breadcrump"
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import changeUrl from "../../hoc/changeur";
import axios from "axios";
import { config } from "../../data/config";
import Swal from "sweetalert2";
import { Avatar, Button, TagInput } from 'rsuite';
import FileUpload from "../tools/chunkupload";
import HeaderOfPage from "../tools/headerOfPage";

export default function StoryDetail() {
    let cookie = getCookies();
    const [list, setList] = useState<any[]>([]);

    const breadcrump = [
        {
            name: 'داشبورد',
            url: '/dashboard'
        },

        {
            name: 'ویژه',
            url: '/dashboard/Feature'
        },
        {
            name: 'استوری',
            url: null
        },
    ]
    const reloaditem = async () => {
        try {
            let res = await axios({
                method: 'get',
                url: config.url + '/v1/dashboard/story',
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;

            setList(res.data.message);
        } catch (error: any) {

        }
    }
    const deleteditem = async (id: any) => {
        try {
            let res = await axios({
                method: 'delete',
                url: config.url + '/v1/dashboard/story/' + id,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;

            reloaditem();
        } catch (error: any) {

        }
    }

    useEffect(() => {
        reloaditem();
    }, []);

    return (
        <>
            <BreadCrump data={breadcrump}></BreadCrump>
            <HeaderOfPage name="مدیریت استوری"></HeaderOfPage>

            <div className="container m-auto">
                <div className="text-right">
                </div>
                <div className="grid grid-cols-12 h-screen bg-slate-100">
                    <div className="col-span-4 p-4 text-right ">
                        <NewStory reloaditem={reloaditem}></NewStory>
                    </div>
                    <div className="col-span-8 text-right p-4 ">
                        <div className={`flex flex-row justify-between   p-1 rounded mb-4 `}>
                            <Button className="bg-transparent" onClick={(e) => { reloaditem() }}> دوباره خوانی</Button>

                        </div>
                        <div>
                            <div className="grid grid-cols-4 gap-2">
                                {
                                    list.map((item: any) => {
                                        return (
                                            <div className="flex flex-col justify-center gap-2 items-center">
                                                <Avatar circle size={`lg`} ></Avatar>
                                                <div className="text-black" >{item.name}</div>

                                                <div className="flex flex-row">
                                                    <Button
                                                        className="font-bold"
                                                        href={`/dashboard/Feature/Story/${item.id}`}
                                                    >ویرایش
                                                    </Button>
                                                    <Button onClick={(e) => { deleteditem(item.id) }}>حذف</Button>
                                                </div>


                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>

                </div>

            </div>


        </>
    )
}

function NewStory({ reloaditem }: any) {
    const { t } = useTranslation();
    const styles = { width: '100%', display: 'block' };

    let cookie = getCookies();
    const [data, setData] = useState<any>({
        name: '',
        tags: [],
        keywords: '',
        description: '',
        username: ''


    });
    const [error, setError] = useState<any>(null);
    const [key, setKey] = useState<any>(1);
    const setName = (name: any) => {


        var x = changeUrl(name);
        setData({ ...data, url: x });
        setData({ ...data, name: name });
    }
    const save = async () => {
        setError(null);

        try {
            let res = await axios({
                method: 'post',
                url: config.url + '/v1/dashboard/story',
                data: data,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });

            let mydata = res.data;
            reloaditem();
            let x = key + 1;
            setKey(x);

        } catch (error: any) {

            error.response.data.code != null && Swal.fire(` "${data.url}" slug is available.`);
            setError(error.response.data.message.errors);
        }
    }

    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    return (
        <div className=" bg-black rounded-[10px] p-5">
            <h4 className="text-white text-[20px] font-bold ">{t(' جدید')}</h4>
            <hr />

            <form key={key}>
                <div className="max-w-sm space-y-3">
                    <label className="text-white">{t('Name')}  </label>
                    <input
                        type="text"
                        className={`${inputstyle}   ${error != null && error['name'] != undefined && `bg-red-100`} `}
                        placeholder="Name"
                        onChange={(e) => { setName(e.target.value);; }}
                    />
                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('نام کاربری')}   </label>
                    <input
                        value={data.url}
                        type="text"
                        className={`${inputstyle}  text-left  ${error != null && error['username'] != undefined && `bg-red-100`}  `}
                        placeholder="Username"
                        onChange={(e) => setData({ ...data, username: e.target.value })}
                    />
                    {error != null && error['username'] != undefined && <small>{error['username']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('توضیحات')}   </label>
                    <textarea
                        value={data.url}
                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}

                        onChange={(e) => setData({ ...data, text: e.target.value })}
                    />
                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <label className="text-white">{t('تگ ها')}   </label>
                    <TagInput
                        defaultValue={data.tags}
                        onChange={(e) => setData({ ...data, tags: e })}
                        placeholder="TAGS" style={styles} />

                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                </div>
                <div className="max-w-sm space-y-3 mt-4">
                    <button type="button"
                        onClick={(e) => { save() }}
                        className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                    >
                        {t('Save')}
                    </button>

                </div>
            </form>
        </div>
    )
}